import { TaskCollectionTravelMode } from '../enums/task-collection-travel-mode.enum';

export function getTransportModeIcon(mode: TaskCollectionTravelMode) {
  switch (mode) {
    case TaskCollectionTravelMode.Cycling:
      return 'la la-biking';
    case TaskCollectionTravelMode.Walking:
      return 'la la-walking';
    case TaskCollectionTravelMode.PublicTransport:
      return 'la la-bus';
    case TaskCollectionTravelMode.Driving:
      return 'la la-car';
    default:
      return '';
  }
}

export function getTransportModeText(mode: TaskCollectionTravelMode) {
  switch (mode) {
    case TaskCollectionTravelMode.Cycling:
      return 'Cycling';
    case TaskCollectionTravelMode.Walking:
      return 'Walking';
    case TaskCollectionTravelMode.PublicTransport:
      return 'Public Transport';
    case TaskCollectionTravelMode.Driving:
      return 'Driving';
    default:
      return '';
  }
}
